import React from "react"
import { Typography, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { RowBox } from "../Boxes"

const useStyles = makeStyles((theme) => ({
  infoSection: {
    minHeight: 48,
  },
  infoTitle: {
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: "600",
    color: theme.palette.text.main,
    whiteSpace: "nowrap",
  },
}))

const InfoTitle = ({ children }) => {
  const classes = useStyles()
  return (
    <Typography variant="h3" className={classes.infoTitle}>
      {children}
    </Typography>
  )
}

const InfoSection = ({ title, value, children, py = 1, px = 2 }) => {
  const classes = useStyles()
  return (
    <RowBox py={py} px={px} className={classes.infoSection} flexGrow={1} align="right">
      {title && <InfoTitle>{title}</InfoTitle>}
      {children}
      {value && <Box ml="auto">{value}</Box>}
    </RowBox>
  )
}

export { InfoTitle, InfoSection }
